import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2373_733",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2373_733)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.33335 11.3331L13.25 6.41642C13.4028 6.26364 13.5972 6.18726 13.8334 6.18726C14.0695 6.18726 14.2639 6.26364 14.4167 6.41642C14.5695 6.5692 14.6459 6.76364 14.6459 6.99976C14.6459 7.23587 14.5695 7.43031 14.4167 7.58309L8.91669 13.0831C8.75002 13.2498 8.55558 13.3331 8.33335 13.3331C8.11113 13.3331 7.91669 13.2498 7.75002 13.0831L5.58335 10.9164C5.43058 10.7636 5.35419 10.5692 5.35419 10.3331C5.35419 10.097 5.43058 9.90253 5.58335 9.74976C5.73613 9.59698 5.93058 9.52059 6.16669 9.52059C6.4028 9.52059 6.59724 9.59698 6.75002 9.74976L8.33335 11.3331Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCheckIcon);
export default ForwardRef;
